export default __webpack_public_path__ + "4ff163c00223023a8f3161e3b2896b2a.png";